import React from 'react'

export interface InquiryIconProps {
    className?: string
    height?: string
    fill?: string
    width?: string
}

export function InquiryIcon({
    className = 'InquiryIcon',
    fill = 'orange',
    height = '200px',
    width = '200px',
}: InquiryIconProps) {
    const fillColor = fill || `fill-brand-black`

    return (
        <div
            className={
                `inline-block ${fillColor} h-[` +
                height +
                `] w-[` +
                width +
                `] ${className}`
            }
        />
    )
}
